// 慣性スクロール

/* =============================================================
 * import
 * ========================================================== */
import {config} from "../config";
import {isMobile, isSafari} from "../utils/utils";
import {ScrollSmoother} from "gsap/ScrollSmoother";

/* =============================================================
 * function
 * ========================================================== */

let smoother = null;
const smooth = 1;
// ScrollSmootherの初期化と再初期化を行う関数
export function initScrollSmoother(data) {

  // 既存のScrollSmootherインスタンスがあれば削除
  if (smoother) {
    smoother.kill();
    smoother = null;
  }

  let smoothScrub;
  let normalizeScrollFlg;
  let effectsFlg;

  // スマホでは無効化
  if (isMobile()) {
    return;
  }

  if (isMobile() || isSafari()) {
    smoothScrub = 0;
    normalizeScrollFlg = false;
    effectsFlg = false;
  } else {
    smoothScrub = smooth;
    normalizeScrollFlg = true; // スクロールをJavaScriptスレッドで強制的に実行し、画面の更新が同期され、[ほとんどの]モバイルデバイスでアドレスバーが表示/非表示にならないようにします。
    effectsFlg = false;
  }

  const ScrollSmootherOpt = { // eslint-disable-line @typescript-eslint/no-unused-vars
    wrapper: '.main',
    content: '.main_container',
    effects: effectsFlg,
    normalizeScroll: normalizeScrollFlg,
    ignoreMobileResize: true,
    smooth: smoothScrub,
    // smoothTouch: 0,  // TODO 細かな最新の設定を再度確認して検収
  };


  // barbaJSが有効＆ページ遷移が発生
  if (config.enableBarba && data) {
    ScrollSmootherOpt.wrapper = data.next.container;
    ScrollSmootherOpt.content = data.next.container.querySelector('.main_container');
    ScrollSmootherOpt.smooth = .1; // ※2
  }

  // ScrollSmootherを初期化
  smoother = ScrollSmoother.create(ScrollSmootherOpt);

  // スクロール位置を最上部に初期化
  smoother.scrollTop(0); // ※1

  /*
   * ※1）
   * barbaJSの遷移時にスクロール位置の調整が必要。
   * 通常はsmoother.scrollTop(0)でスクロール位置を最上部に調整する形でOK。

   * ※2）
   * data-scroll-hashを用いてページ遷移後に特定のスクロール位置にアンカーリンクが必要な場合、
   * 遷移後に最上部に初期化→アンカーの位置にスムーズスクロールというカクツキが発生してしまう。ScrollSmoother初期化時の仕様。
   * スムーズスクロールのdurationがsmoother.smoothの量に比例するため、最小値に設定して、アニメーションを最小限に留める。
   * 遷移後のスクロール位置の調整が完了後、再度smoother.smooth(1)などで、必要な量に再調整する。
   * ただし、0にすると位置の取得ないし、調整がずれてしまうため、あくまで0を除いた最小値にすること。
   * */
}


export function resetSmoothScrollSmoother() {
  const smoother = ScrollSmoother.get();
  smoother.smooth(smooth);
}

/*
// ScrollSmoother.get();に代替できるので削除
// オプショナル: 外部からScrollSmootherのインスタンスにアクセスできるようにする
export function getSmoother() {
  return smoother;
}
*/
